module.exports = __webpack_public_path__ + "img/il-no-feature-ideas.f099541.svg";